<template>
  <div class="new-release" v-show="cars.length > 0" @click.stop>
    <div class="new-release__container">
      <!-- 标题栏 -->
      <div class="new-release__title">
        <div class="new-release__heading">New Release Rank</div>
        <a :href="allCarsLink" class="new-release__view">
          <div class="new-release__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="new-release__icon" alt="">
        </a>
      </div>

      <!-- 内容区域 -->
      <div class="new-release__content">
        <!-- 加载状态 - 临时隐藏 -->
        <!-- <div v-if="loading" class="new-release__loading">
          <div class="new-release__loading-text">Loading...</div>
        </div> -->

        <!-- 正常内容显示 -->
        <template>
          <!-- 卡片展示区域 -->
          <div class="new-release__cards">
            <a v-for="(car, index) in displayedCars" :key="`car-${index}`" class="new-release__card"
              :href="getDetailLink(car)" :data-empty="car.isEmpty">
              <!-- 顶部信息区域：车型和品牌 -->
              <div class="new-release__header">
                <div class="new-release__details">
                  <div class="new-release__model">{{ car.model }}</div>
                  <div class="new-release__brand">{{ car.brand }}</div>
                </div>
                <div class="new-release__logo">
                  <img :src="car.logo" alt="">
                </div>
              </div>

              <!-- 车辆图片 -->
              <div class="new-release__image-container">
                <img :src="car.image" class="new-release__pic" alt="">
              </div>

              <!-- 底部信息区域 -->
              <div class="new-release__footer">
                <!-- 价格 -->
                <div class="new-release__info-row">
                  <img src="@/assets/price-tag.svg" class="new-release__info-icon" alt="">
                  <div class="new-release__info-text">{{ car.price }}</div>
                </div>

                <!-- 车辆类型 -->
                <div class="new-release__info-row">
                  <img src="@/assets/car-type.svg" class="new-release__info-icon" alt="">
                  <div class="new-release__info-text">{{ car.category }}</div>
                </div>

                <!-- 车型 -->
                <div class="new-release__info-row">
                  <img src="@/assets/body-type.svg" class="new-release__info-icon" alt="">
                  <div class="new-release__info-text">{{ car.bodyType }}</div>
                </div>

                <!-- 发布时间 -->
                <div class="new-release__release">
                  <div class="new-release__release-label">Release time</div>
                  <div class="new-release__release-time">{{ car.releaseTime }}</div>
                  <img src="@/assets/arrow_outward.svg" class="new-release__release-icon" alt="">
                </div>
              </div>
            </a>
          </div>

          <!-- 导航按钮和指示器 - 仅在PC端显示且有多页时显示 -->
          <div class="new-release__nav" v-if="deviceType !== 'mobile' && totalPages > 1">
            <div class="new-release__nav-arrow new-release__nav-prev" @click="prevPage">
              <img src="@/assets/arrow-left-blue.svg" alt="Previous">
            </div>

            <div class="new-release__nav-dots">
              <div v-for="n in totalPages" :key="`dot-${n}`" class="new-release__nav-dot"
                :class="{'new-release__nav-dot--active': currentPage === n}" @click="goToPage(n)">
              </div>
            </div>

            <div class="new-release__nav-arrow new-release__nav-next" @click="nextPage">
              <img src="@/assets/arrow-right-blue.svg" alt="Next">
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarNewRelease',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      const currentChannel = this.$route.params.channel;
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';
      let path = '/car-list';
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }
      return `${path}${queryString}`;
    },
    // 计算当前显示的卡片
    displayedCars () {
      // 移动端展示所有车辆，不做分页
      if (this.deviceType === 'mobile') {
        return this.cars;
      }

      // PC端保持原来的分页逻辑
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const items = this.cars.slice(start, start + this.itemsPerPage);

      // 如果不足4个，填充到4个以保持布局一致
      while (items.length < this.itemsPerPage && items.length > 0) {
        items.push({ ...items[0], isEmpty: true });
      }

      return items;
    },
    // 计算总页数
    totalPages () {
      return Math.ceil(this.cars.length / this.itemsPerPage);
    }
  },
  data () {
    return {
      currentPage: 1,
      itemsPerPage: 4,
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchNewRelease();
  },
  methods: {
    // 获取新发布车型数据
    async fetchNewRelease () {
      this.loading = true;
      this.error = null;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};

        // 调用global.js中的getRecommendedNewReleaseRank方法获取数据
        const res = await this.$global.server.getRecommendedNewReleaseRank(themeFilters);
        if (res.code === 200) {
          // 处理API返回的数据
          const apiData = res.data || [];
          const processedData = apiData.map(item => {
            // 从photos字段提取第一张图片作为封面
            const photos = item.photos ? item.photos.split(',') : [];
            const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

            // 格式化发布时间
            let releaseTime = item.marketTime || item.year || '-';
            if (releaseTime && releaseTime.length >= 7) {
              releaseTime = releaseTime.substring(0, 7).replace('-', '.');
            }

            // 返回处理后的数据，映射字段名称
            return {
              id: item.id,
              model: item.name, // API中是name字段，映射为model
              brand: item.brand,
              logo: item.logoUrl || require('@/assets/car-logo.svg'), // 优先使用接口返回的logoUrl字段，没有则使用默认logo
              year: item.year || item.marketTime?.substring(0, 4) || '-',
              category: item.purpose || '-', // 使用purpose字段作为category
              bodyType: item.type || '-', // 使用type字段作为bodyType
              price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
              image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
              releaseTime: releaseTime,
              isEmpty: false
            };
          });

          this.cars = processedData;
          console.log('[CarNewRelease] 获取新车发布排名:', this.cars.length);
          // 重置当前页为第一页
          this.currentPage = 1;
        } else {
          // 如果没有数据，则设置为空数组
          this.cars = [];
          console.log('[CarNewRelease] 没有新车发布排名数据');
        }
      } catch (error) {
        console.error('[CarNewRelease] 获取新车发布排名错误:', error);
        this.error = error.message || 'Failed to get new release rank';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    getDetailLink (car) {
      if (!car || !car.id || car.isEmpty) {
        return '#';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const query = this.$route.query;
      const queryString = Object.keys(query).length > 0 ? `?${new URLSearchParams(query).toString()}` : '';

      let path = `/cars/${formattedName}/${car.id}`;
      if (currentChannel) {
        path = `/${currentChannel}${path}`;
      }

      return `${path}${queryString}`;
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 上一页
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    // 下一页
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    // 跳转到指定页
    goToPage (page) {
      this.currentPage = page;
    },
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.new-release {
	padding: rem(50) rem(120);
	background: #ffffff;

	&__container {
		max-width: rem(1200);
		margin: 0 auto;
	}

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
	}

	&__heading {
		font-size: rem(30);
		line-height: rem(30);
		font-weight: 700;
		color: #050b20;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		width: rem(14);
		height: rem(14);
	}

	&__content {
		display: flex;
		flex-direction: column;
		width: 100%;
		position: relative;
		// min-height: rem(300);
	}

	&__cards {
		display: flex;
		gap: rem(20);
		overflow: hidden;
	}

	&__loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__loading-text {
		font-size: rem(18);
		font-weight: 700;
		color: #405ff2;
	}

	&__error {
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(200);
		width: 100%;
	}

	&__error-text {
		font-size: rem(18);
		font-weight: 700;
		color: #ff0000;
	}

	&__card {
		flex: 1 0 calc(25% - rem(15));
		position: relative;
		border-radius: rem(12);
		border: 1px solid #e9e9e9;
		background: #f9fbfc;
		overflow: hidden;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		padding: rem(20) rem(16);
		gap: rem(16);

		&[data-empty='true'] {
			visibility: hidden;
		}
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__details {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__model {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
		color: #050b20;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		color: #848998;
	}

	&__logo {
		width: rem(36);
		height: rem(36);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		object-fit: cover;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	&__logo img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&__image-container {
		width: 100%;
		height: rem(168);
		border-radius: rem(12);
		overflow: hidden;
	}

	&__pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__footer {
		display: flex;
		flex-direction: column;
		gap: rem(8);
	}

	&__info-row {
		display: flex;
		align-items: center;
		gap: rem(8);
	}

	&__info-icon {
		width: rem(16);
		height: rem(16);
	}

	&__info-text {
		font-size: rem(12);
		line-height: rem(12);
		color: #050b20;
	}

	&__release {
		display: flex;
		flex-direction: column;
		position: relative;
		margin-top: rem(8);
		padding-top: rem(16);
		border-top: 1px solid rgba(5, 11, 32, 0.1);
	}

	&__release-label {
		font-size: rem(12);
		line-height: rem(12);
		color: #848998;
	}

	&__release-time {
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
		color: #050b20;
		margin-top: rem(8);
	}

	&__release-icon {
		width: rem(16);
		height: rem(16);
		position: absolute;
		right: 0;
		bottom: 0;
	}

	&__nav {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-top: rem(20);
		gap: rem(20);
	}

	&__nav-dots {
		display: flex;
		gap: rem(8);
		align-items: center;
	}

	&__nav-dot {
		width: rem(8);
		height: rem(8);
		background-color: #e0e0e0;
		border-radius: 50%;
		cursor: pointer;
		transition: all 0.3s ease;

		&--active {
			background-color: #405ff2;
		}
	}

	&__nav-arrow {
		width: rem(40);
		height: rem(40);
		border-radius: 8px;
		border: 1px solid rgba(#405ff2, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			border: 1px solid rgba(#405ff2, 0.6);
		}

		img {
			width: rem(20);
			height: rem(20);
		}
	}
}

// 移动端适配
.detect_deviece_mobile {
	.new-release {
		padding: rem(30) rem(16);

		&__cards {
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			gap: rem(16);
			padding-bottom: rem(10);
			scrollbar-width: none;
			-ms-overflow-style: none;
			&::-webkit-scrollbar {
				display: none;
			}
			margin: 0 rem(-16);
			padding: 0 rem(16);
			width: calc(100% + rem(32));
		}

		&__card {
			flex: 0 0 rem(280);
			min-width: rem(280);
		}

		&__heading {
			font-size: rem(24);
			line-height: rem(24);
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.new-release {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.new-release {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
	}
}
</style> 